import React, { ReactNode } from 'react';
import { AuthProvider } from './AuthContext';
import { CartProvider } from './CartContext';
import { AuctionProvider } from './AuctionContext';
import { UIProvider } from './UIContext';

interface AppProvidersProps {
  children: ReactNode;
}

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  return (
    <AuthProvider>
      <CartProvider>
        <AuctionProvider>
          <UIProvider>
            {children}
          </UIProvider>
        </AuctionProvider>
      </CartProvider>
    </AuthProvider>
  );
};

// Re-export all hooks for convenience
export { useAuth } from './AuthContext';
export { useCart } from './CartContext';
export { useAuction } from './AuctionContext';
export { useUI, MenuItems } from './UIContext';

// Re-export types
export type { ParsedAuction } from './AuctionContext';
